import React, { useState, useEffect, Fragment } from "react";
import _ from "lodash";

import { useSelector, useDispatch } from "react-redux";

import { locationActions } from "../../redux/actions";

import Skeleton from "react-loading-skeleton";
import Card from "../../component/card/Card";
import { helperFunction } from "../../constant/helper";

import Starter from "../../component/Starter";

const AllLocation = () => {
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();

  const [allLocations, setAllLocations] = useState([]);

  const {
    locationError,
    locationResponse,
    locations,
    numberOfActiveUsers
  } = useSelector((state) => state.location);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
  }, [locationError]);

  useEffect(() => {
    if (locationResponse) {
      helperFunction.toastHelper("success", locationResponse);
    }
  }, [locationResponse]);

  // useEffect(() => {
  //   setAllLocations(locations);
  //   console.log(locations);
  // }, [locations]);

  // console.log(numberOfActiveUsers);

  useEffect(() => {
    if (
      typeof numberOfActiveUsers !== "undefined" &&
      typeof locations !== "undefined"
    ) {
      const newArray = [];
      const mapData = _.mapKeys(locations, "_id");
      numberOfActiveUsers.forEach((userValue) => {
        return newArray.push({
          totalCount: userValue.total,
          _id: mapData[userValue.locationId]?._id,
          latitude: mapData[userValue.locationId]?.latitude,
          longitude: mapData[userValue.locationId]?.longitude,
          locationCity: mapData[userValue.locationId]?.locationCity,
          locationCode: mapData[userValue.locationId]?.locationCode,
          locationName: mapData[userValue.locationId]?.locationName,
          locationType: mapData[userValue.locationId]?.locationType,
          locationState: mapData[userValue.locationId]?.locationState
        });
      });
      // console.log(newArray);
      setAllLocations(newArray);
    }
  }, [numberOfActiveUsers, locations]);

  useEffect(() => {
    dispatch(locationActions.setLocationLoading(true));
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    dispatch(locationActions.getAllLocation(loginType));
    return () => {
      dispatch(locationActions.setLocationLoading(false));
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
      dispatch(locationActions.unmountAllLocationsData());
    };
  }, []);

  const showLocationList = () => {
    if (
      typeof allLocations !== "undefined" &&
      allLocations !== null &&
      allLocations.length > 0
    ) {
      return allLocations.map((singleLocation, index) => (
        <tr key={index}>
          <td>
            <span className="">{index + 1}</span>
          </td>
          <td>
            <span className="">{singleLocation.locationName}</span>
          </td>
          <td>
            <span className="">{singleLocation.locationType}</span>
          </td>
          <td>
            <span className="">{singleLocation.latitude}</span>
          </td>
          <td>
            <span className="">{singleLocation.longitude}</span>
          </td>
          <td>
            <span className="">{singleLocation.locationState}</span>
          </td>
          <td>
            <span className="">{singleLocation.totalCount}</span>
          </td>
        </tr>
      ));
    } else if (allLocations === null) {
      return (
        <tr>
          <td>
            <Skeleton count={1} />
          </td>
          <td>
            <Skeleton count={1} />
          </td>
          <td>
            <Skeleton count={1} />
          </td>
          <td>
            <Skeleton count={1} />
          </td>
          <td>
            <Skeleton count={1} />
          </td>
          <td>
            <Skeleton count={1} />
          </td>
          <td>
            <Skeleton count={1} />
          </td>
        </tr>
      );
    } else if (allLocations.length === 0) {
      return (
        <tr>
          <td>No Record Found</td>
        </tr>
      );
    }
  };

  return (
    <Starter
      topBarTitle="All Locations"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Registration Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Locations</a>
          </li>
          <li className="breadcrumb-item active">All Locations</li>
        </Fragment>
      }
    >
      <Card>
        <div className="table-responsive">
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>
                <th>Location Name</th>
                <th>Location Type</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>State</th>
                <th>Active Users</th>

                {/* <th>Actions</th> */}
              </tr>
            </thead>
            <tbody>{showLocationList()}</tbody>
          </table>
        </div>
      </Card>
    </Starter>
  );
};

export default AllLocation;
